module.exports = __webpack_public_path__ + "static/media/Untamed Logo.6e6047e9.jpg";